import React, { lazy } from 'react';

import { componentLoader } from '@nw/shared/utils';

// Lazy load confetti so react-canvas-confetti stays in a separate chunk (not in initial bundle).
const LazyConfettiComponent = lazy(
  () =>
    componentLoader(() =>
      import(
        /* webpackChunkName: "ConfettiComponent" */ './confettiComponent'
      ).then((m) => ({ default: m.ConfettiComponent }))
    ) as Promise<{ default: React.ComponentType<any> }>
);

export { LazyConfettiComponent };